import { Component, EventEmitter, OnInit, OnDestroy, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

import { TranslateService } from '@ngx-translate/core';

import { CustomerFacade, NotificationFacade } from '@ridango/components';

import { Observable } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { BaseComponent } from '@ridango/core';
import { phoneValidNumberValidator } from '@ridango/core/lib/validators/phone.validator';

@Component({
    selector: 'rwidget-customer-account-edit',
    templateUrl: './customer-account-edit.component.html',
    styleUrls: ['./customer-account-edit.component.scss']
})
export class CustomerAccountEditComponent extends BaseComponent implements OnInit, OnDestroy {
    _customerForm: FormGroup;

    @Output() onEditSuccess = new EventEmitter<any>();

    profile$: Observable<any> = this.customerFacade.profile$;
    loaded$: Observable<boolean> = this.customerFacade.loaded$;
    customerFields$: Observable<string[]> = this.customerFacade.customerFields$;
    isFormSubmitted$: Observable<boolean> = this.customerFacade.isFormSubmitted$;

    constructor(
        private customerFacade: CustomerFacade,
        private notification: NotificationFacade,
        private translate: TranslateService
    ) {
        super();
    }

    ngOnInit() {
        this._customerForm = new FormGroup({
            name: new FormControl(''),
            phone: new FormControl('', [phoneValidNumberValidator]),
            adr_city: new FormControl(''),
            adr_street_1: new FormControl(''),
            adr_zip: new FormControl('')
        });

        this.customerFacade.getCustomerProfile();
        this.customerFacade.profile$
            .pipe(takeUntil(this.componentDestroyed$))
            .subscribe((d) => this._customerForm.patchValue(d));

        this.customerFacade.isFormSubmitted$.pipe(takeUntil(this.componentDestroyed$)).subscribe((isSubmitted) => {
            if (isSubmitted) {
                this.customerFacade.error$.pipe(take(1)).subscribe((error) => {
                    if (error) {
                        this.handleError(error);
                    } else {
                        this.notification.success(this.translate.instant('LOCAL_PROFILE_SAVED_SUCCESS'), {
                            title: this.translate.instant('LOCAL_NOTIFICATION_HEADING_SUCCESS'),
                            showAfterRouteChange: true
                        });
                        this.onEditSuccess.emit();
                    }
                });
            }
        });
    }

    submitProfile() {
        if (this._customerForm.valid) {
            this.customerFacade.saveCustomerProfile({ ...this._customerForm.value, lang: this.translate.currentLang });
        }
    }

    handleError(e: any) {
        if (e.error.description) {
            this.notification.error(this.translate.instant(e.error.description));
        } else {
            this.notification.error(this.translate.instant(e.error));
        }
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
